import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.5 18.5V8c0-1.2 1.667-2.167 2.5-2.5 2.5 1 2.5 2.5 2.5 2.5v10.5h-5Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M2.5 21.5v-19h19v19h-19Z" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.5 10.5v-1h1v1h-1ZM17.5 10.5v-1h1v1h-1ZM5.5 15.5v-1h1v1h-1ZM17.5 15.5v-1h1v1h-1Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }